import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sr-only',
  templateUrl: './sr-only.component.html',
  styleUrls: ['./sr-only.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SrOnlyComponent {}

